export default __webpack_public_path__ + "static/media/left-dots.e6ac543d.svg";